<div *ngIf="slides; else slidesLoading">
  <div *ngIf="newVersion; else oldVersion">
    <div class="image-carousel" style="padding: 0">
      <app-carousel
        [newVersion]="newVersion"
        [slides]="slides"
        [autoSlideInterval]="5000"
        (slideClickedAtIndex)="slideClicked($event)"
      ></app-carousel>
    </div>
  </div>
  <ng-template #oldVersion>
    <mat-card appearance="outlined" class="image-carousel" style="padding: 0">
      <app-carousel
        [newVersion]="newVersion"
        [slides]="slides"
        [autoSlideInterval]="5000"
        (slideClickedAtIndex)="slideClicked($event)"
      ></app-carousel>
    </mat-card>
  </ng-template>
</div>
<ng-template #slidesLoading>
  <div>
    <store-card-stencil></store-card-stencil>
  </div>
</ng-template>
